import AOS from "aos";
import Rellax from "rellax";
import Glide, { Controls } from "@glidejs/glide";
import "../../widgets/longtext/_longtext";
import "../../widgets/boutons/_boutons";
import "../../widgets/feed/_feed";
import "../../widgets/sgos/_sgo";
import "../../widgets/search/_search";
import "../../widgets/products/_product";
import "../../widgets/forms/_form";
import "../../widgets/account/_blogposting";

function urlToPromise(url) {
	return new Promise(function (resolve, reject) {
		JSZipUtils.getBinaryContent(url, function (err, data) {
			if (err) {
				reject(err);
			} else {
				resolve(data);
			}
		});
	});
}
//import "aos/dist/aos.css";
window.addEventListener("DOMContentLoaded", () => {
	AOS.init({
		disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
		startEvent: "DOMContentLoaded", // name of the event dispatched on the document, that AOS should initialize on
		debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
		throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
		// Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
		offset: 120, // offset (in px) from the original trigger point
		delay: 100, // values from 0 to 3000, with step 50ms
		duration: 300, // values from 0 to 3000, with step 50ms
		easing: "ease", // default easing for AOS animations
		once: true, // whether animation should happen only once - while scrolling down
		mirror: false, // whether elements should animate out while scrolling past them
		anchorPlacement: "top-bottom",
	});
	let rellax = new Rellax(".rellax", {
		center: true,
	});
	if (document.querySelector("#mobile-header")) {
		let header = document.querySelector("#mobile-header");
		let hamburger = header.querySelector(".barre .dots");
		hamburger.addEventListener("click", () => {
			header.classList.toggle("open");
		});
	}
	if (document.querySelector(".glide")) {
		new Glide(".glide", {
			startAt: 0,
			perView: 1,
		}).mount();
	}
	if (document.querySelector(".glide_caroussel")) {
		new Glide(".glide_caroussel", {
			startAt: 0,
			perView: 4,
			gap: 20,
			type: "slider",
		}).mount();
	}
	if (document.querySelector(".glide_feed")) {
		new Glide(".glide_feed", {
			startAt: 0,
			perView: 4,
			touchRatio: 0.5,
			gap: 20,
			animationDuration: 800,
			type: "slider",
			rewind: false,
			perTouch: 2,
			focusAt: 0,
			bound: true,
			dragThreshold: 50,
			breakpoints: {
				1400: {
					perView: 3,
				},
				1200: {
					perView: 2,
				},
				600: {
					perView: 1,
				},
			},
		}).mount();
	}
	if (document.getElementById("badges_download")) {
		document.querySelector("#badges_download .ngo_button").addEventListener("click", (e) => {
			e.preventDefault();
			var zip = new JSZip();
			let badges = document.querySelectorAll(".badge_list .badge img");
			if (badges) {
				badges.forEach((el, index) => {
					zip.file(`${el.title}.png`, urlToPromise(el.src), { binary: true });
				});
			}

			zip.generateAsync({ type: "blob" }).then((content) => {
				saveAs(content, "thedotgood_badges.zip");
			});
		});
	}
});
